// @flow
/** @jsx jsx */

import { isFunction } from 'lodash';

import { css, jsx } from '@emotion/core';
import { Colors } from '@zapier/design-system';

import { type Node } from 'react';

type Props = {
  children?: Node,
  isEditing?: boolean,
  renderAside?: () => Node,
  renderLabel?: () => Node,
};

const containerCss = props => {
  return {
    border: `1px solid ${props.isEditing ? Colors.blue500 : Colors.grey300}`,
    borderRadius: 10,
    padding: 15,
    position: 'relative',
  };
};

const headerCss = css`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto;
  min-height: 40px;
`;

const headerLabelCss = {
  display: 'flex',
  alignItems: 'center',

  '> *': {
    marginRight: 20,
  },
};

const sectionCss = {
  marginTop: 20,
};

const PaymentMethod = (props: Props) => (
  <section css={containerCss(props)}>
    <header css={headerCss}>
      <div css={headerLabelCss}>
        {isFunction(props.renderLabel) && props.renderLabel()}
      </div>
      {isFunction(props.renderAside) && props.renderAside()}
    </header>
    {props.isEditing && props.children && (
      <div css={sectionCss}>{props.children}</div>
    )}
  </section>
);

export default PaymentMethod;
